var map = {
	"./404.json": 1590,
	"./account.json": 8429,
	"./blockbuster.json": 4042,
	"./cinema.json": 8310,
	"./faq.json": 9014,
	"./footer.json": 3160,
	"./get-started.json": 5829,
	"./header.json": 4734,
	"./index.json": 658,
	"./info.json": 1836,
	"./privacy.json": 9411,
	"./sign-in.json": 5525,
	"./subreader-ambassadoer.json": 6522,
	"./subscription.json": 7183,
	"./terms.json": 2852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3852;